import { render, staticRenderFns } from "./AdminControl.vue?vue&type=template&id=5c50c178&scoped=true&"
import script from "./AdminControl.vue?vue&type=script&lang=js&"
export * from "./AdminControl.vue?vue&type=script&lang=js&"
import style0 from "./AdminControl.vue?vue&type=style&index=0&id=5c50c178&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c50c178",
  null
  
)

export default component.exports